{
  "testRamp": {
    "layout": "Layout",
    "iterativeMode": "Iterative Mode",
    "showCurvedLines": "Show Curved Lines",
    "showAircraftImages": "Show Aircraft Images",
    "datasetSize": "Dataset Size",
    "useSpaceQuality": "Use Space Quality Optimization",
    "qualityMetric": "Quality Metric",
    "optimizationLevel": "Optimization Level",
    "safetyBufferMode": "Safety Buffer Mode",
    "priorityFirstSorting": "Priority-First Sorting",
    "showAreas": "Show Areas",
    "showObstacles": "Show Obstacles",
    "legends": {
      "obstacles": "Obstacles",
      "noGoZones": "No-Go Zones"
    }
  }
}
